import { render, staticRenderFns } from "./DanhSachNguoiDungKhongThuocGroup.vue?vue&type=template&id=45f5b55b&scoped=true&"
import script from "./DanhSachNguoiDungKhongThuocGroup.vue?vue&type=script&lang=js&"
export * from "./DanhSachNguoiDungKhongThuocGroup.vue?vue&type=script&lang=js&"
import style0 from "./DanhSachNguoiDungKhongThuocGroup.vue?vue&type=style&index=0&id=45f5b55b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f5b55b",
  null
  
)

export default component.exports